import { Divider, Stack, Typography } from '@mui/material';

import { Loader } from '@/components/layout/loading';
import { Tag } from '@/components/tag';
import { TagsSection } from '@/components/tags/tagsSection';

export const RestoreAccountConfigCustomTags = ({
  tags,
  onChange,
  isLoading,
}: {
  tags: Record<string, string>;
  onChange: (tags: Record<string, string>) => void;
  isLoading: boolean;
}) => {
  return (
    <Stack
      height='100%'
      paddingY='40px'
      paddingX='100px'
      gap='40px'
      divider={<Divider sx={{ borderStyle: 'dashed' }} />}
    >
      <Stack direction='row' gap='12px' alignItems='center'>
        <Typography variant='subtitle1'>
          {`To help identify the temporary server, we’ll add this tag:`}
        </Typography>
        <Tag variant='secondary' content='eon:service=true' />
      </Stack>
      <TagsList loading={isLoading} tags={tags} onChange={onChange} />
    </Stack>
  );
};

const TagsList = (props: {
  loading: boolean;
  tags: Record<string, string>;
  onChange: (tags: Record<string, string>) => void;
}) => {
  return (
    <div className='ml-[-40px] max-w-[920px]'>
      {props.loading && (
        <Stack className='mt-[50px]'>
          <Loader />
        </Stack>
      )}
      {!props.loading && (
        <TagsSection
          tags={props.tags}
          initialTags={props.tags}
          keepOriginalTags={false}
          onChange={(updated) => {
            props.onChange(updated);
          }}
        />
      )}
    </div>
  );
};
